import BasicResource from '@/api/resource';

class ApprovalsResource extends BasicResource {

    constructor () {
        super('approvals');
    }

    decide (id, decision, params) {
        return this.client.request ({
            method: 'post',
            path: `/upyield/v1/approvals/${id}/${decision}`,
            params,
        });
    }

    approve (id, params) {
        return this.decide (id, 'approve', params);
    }

    reject (id, params) {
        return this.decide (id, 'reject', params);
    }

    retrieve (id, params) {
        return this.decide (id, 'revert', params);
    }

    bulkApprove (payload) {
        return this.client.request ({
            method: 'put',
            path: '/upyield/v1/approvals/bulk-approve',
            data: payload,
        });
    }
}

export default new ApprovalsResource;
